export interface LeadStageSummaryRow {
  lead_id: number;
  owner_name: string;
  company_name: string | null;
  created_date: string | null;
  modified_date: string | null;
  mql: number;
  non_contactable: number;
  open: number;
  total_time: number;
  final_stage_name: string | null;
}

export interface LeadStageSummaryPaginatedResponse {
  limit: number;
  page_no: number;
  total_count: number;
  total_pages: number;
  list: LeadStageSummaryRow[];
  status_summary: LeadStatusSummaryItem[];
  pipeline_status_summary?: LeadPipelineStatusSummaryGroup[];
  averages: LeadStageAverages;
  section: LeadSection;
}

export interface LeadStageSummaryListResponse {
  limit: number;
  page_no: number;
  total_count: number;
  total_pages: number;
  list: LeadStageSummaryRow[];
}

export interface LeadStageAveragesResponse {
  averages: LeadStageAverages;
  section: LeadSection;
}

export interface LeadPipelineStatusSummaryGroup {
  pipeline_id: number;
  pipeline_name: string;
  total_count: number;
  status_summary: LeadStatusSummaryItem[];
}

export interface LeadStageStatusSummaryResponse {
  total_count: number;
  status_summary: LeadStatusSummaryItem[];
  pipeline_status_summary?: LeadPipelineStatusSummaryGroup[];
  section: LeadSection;
}

export type LeadSection = "open" | "closed" | "all";

export const LEAD_SECTION_FILTER_OPTIONS: Array<{ id: LeadSection; value: string }> = [
  { id: "all", value: "All Leads" },
  { id: "open", value: "Open Leads" },
  { id: "closed", value: "Closed Leads" },
];

export interface LeadStatusSummaryItem {
  final_status: string;
  lead_count: number;
  lead_percent: number;
}

export interface LeadStageAverages {
  mql: number;
  non_contactable: number;
  open: number;
  total_time: number;
}
